import { render } from "./EdicionCliente.vue?vue&type=template&id=c83b5398&scoped=true"
import script from "./EdicionCliente.js?vue&type=script&lang=js"
export * from "./EdicionCliente.js?vue&type=script&lang=js"

import "./EdicionCliente.vue?vue&type=style&index=0&id=c83b5398&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83b5398"]])

export default __exports__